import {
  dataSourcesActionCreators,
  dataSourcesStardogRequestDispatchers,
} from 'src/actions/data-sources/actionCreators';
import { isStardogFeatureSupportedSelector } from 'src/selectors/isStardogFeatureSupported';
import { AppDispatch } from 'src/store/store';
import { ReduxStateGetter } from 'src/store/types';

export const refreshDataSources =
  () => async (dispatch: AppDispatch, getState: ReduxStateGetter) => {
    dispatch(dataSourcesActionCreators.refreshDataSourcesStarted());

    const state = getState();
    const { connection } = state.connections;
    if (!connection) {
      dispatch(dataSourcesActionCreators.refreshDataSourcesFinished());
      return;
    }

    const isDataSourceDescriptionEndpointSupported =
      isStardogFeatureSupportedSelector(
        'isDataSourceDescriptionEndpointSupported',
        connection
      )(state);

    if (isDataSourceDescriptionEndpointSupported) {
      await dataSourcesStardogRequestDispatchers.requestDataSourceTypeDescription(
        connection
      );
    }

    await dataSourcesStardogRequestDispatchers.requestDataSourceListInfo();

    dispatch(dataSourcesActionCreators.refreshDataSourcesFinished());
  };
